import React, { useEffect, useRef, useState } from 'react';
import './Map.css';

function Map() {
  const mapRef = useRef(null);
  const [activeMarker, setActiveMarker] = useState(null);
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [leafletLoaded, setLeafletLoaded] = useState(false);
  
  // Coordonnées des villes (lat, lng)
  const deliveryLocations = [
    { id: 1, name: "Lyon", position: { lat: 45.7640, lng: 4.8357 }, isMainHub: true },
    { id: 2, name: "Albertville", position: { lat: 45.6754, lng: 6.3923 }, isMainHub: true },
    { id: 3, name: "Saint-Étienne", position: { lat: 45.4397, lng: 4.3872 } },
    { id: 4, name: "Annonay", position: { lat: 45.2394, lng: 4.6659 } },
    { id: 5, name: "Vienne", position: { lat: 45.5241, lng: 4.8775 } },
    { id: 6, name: "Bourgoin-Jallieu", position: { lat: 45.5883, lng: 5.2728 } },
    { id: 7, name: "Voiron", position: { lat: 45.3628, lng: 5.5910 } },
    { id: 8, name: "Grenoble", position: { lat: 45.1885, lng: 5.7245 } },
    { id: 9, name: "Chambéry", position: { lat: 45.5644, lng: 5.9175 } },
    { id: 10, name: "Aix-les-Bains", position: { lat: 45.6928, lng: 5.9108 } },
    { id: 11, name: "Annecy", position: { lat: 45.8992, lng: 6.1286 } }
  ];
  
  // Load Leaflet library
  useEffect(() => {
    // Load Leaflet CSS
    if (!document.getElementById('leaflet-css')) {
      const linkElement = document.createElement('link');
      linkElement.id = 'leaflet-css';
      linkElement.rel = 'stylesheet';
      linkElement.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      linkElement.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
      linkElement.crossOrigin = '';
      document.head.appendChild(linkElement);
    }
    
    // Load Leaflet JS
    if (!window.L) {
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
      script.crossOrigin = '';
      script.onload = () => {
        setLeafletLoaded(true);
      };
      document.head.appendChild(script);
    } else {
      setLeafletLoaded(true);
    }
    
    return () => {
      // Cleanup isn't really needed for script/css loaded once
    };
  }, []);
  
  // Initialize map once Leaflet is loaded
  useEffect(() => {
    if (!leafletLoaded || !mapRef.current) return;
    
    const L = window.L; // Access Leaflet from window to avoid ESLint errors
    
    // Create the map centered between Lyon and Albertville
    const newMap = L.map(mapRef.current).setView([45.65, 5.5], 9);
    
    // Add the OpenStreetMap tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(newMap);
    
    setMap(newMap);
    
    // Add the markers
    const newMarkers = deliveryLocations.map(location => {
      // Create custom icon based on location type
      const markerIcon = L.divIcon({
        className: location.isMainHub ? 'main-hub-marker' : 'location-marker',
        iconSize: location.isMainHub ? [24, 24] : [18, 18],
        html: `<div class="${location.isMainHub ? 'main-hub-icon-leaflet' : 'location-icon-leaflet'}"></div>`
      });
      
      // Create marker
      const marker = L.marker(
        [location.position.lat, location.position.lng],
        { icon: markerIcon, title: location.name }
      ).addTo(newMap);
      
      // Add popup
      const popup = L.popup({ className: 'custom-popup' })
        .setContent(`<div class="marker-info">${location.name}</div>`);
      
      // Add click handler
      marker.on('click', () => {
        if (activeMarker) {
          activeMarker.marker.closePopup();
        }
        
        marker.openPopup();
        setActiveMarker({ marker, id: location.id });
      });
      
      marker.bindPopup(popup);
      
      return { marker, id: location.id };
    });
    
    setMarkers(newMarkers);
    
    // Cleanup
    return () => {
      if (newMap) {
        newMap.remove();
      }
    };
  }, [leafletLoaded, activeMarker]);
  
  return (
    <div className="map-container">
      <h2 className="map-title">Nos points de livraison</h2>
      
      <div className="map-visualization">
        <div ref={mapRef} id="leaflet-map"></div>
      </div>
      
      <div className="map-legend">
        <div className="legend-item">
          <div className="legend-icon main-hub-icon"></div>
          <span>Centres principaux</span>
        </div>
        <div className="legend-item">
          <div className="legend-icon location-icon"></div>
          <span>Points de livraison</span>
        </div>
      </div>
      
      <div className="map-info">
        <p className="map-tagline">Nous livrons votre WoodyBooth dans toute la région Auvergne-Rhône-Alpes</p>
      </div>
    </div>
  );
}

export default Map;